import React, { useRef } from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import { useFocus } from 'react-native-web-hooks';
import Text from '../text';
import Colors from '../colors';
import Icon from '../icon';
const StyledTextInput = styled.TextInput`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  height: 50px;
  padding-left: ${props => props.prefix || props.lefticon !== '' ? '52px' : '12px'};
  padding-right: ${props => props.righticon !== '' ? '52px' : '12px'};
  background: ${props => props.disabled ? Colors.lightGray200 : Colors.lightGray100};
  border: 1px solid;
  border-color: ${props => props.disabled ? Colors.lightGray300 : props.error ? Colors.error400 : Colors.lightGray500};
  box-sizing: border-box;
  border-radius: 4px;
  align-self: stretch;
  margin: 2px 0px;
  font-family: Larsseit;
  font-size: 16px;
  font-style: normal;
  outline-color: ${Colors.advanceBlue400};
  color: ${Colors.gray600};
  placeholder-text-color: ${props => props.disabled ? Colors.lightGray500 : Colors.gray200};
`;
const Prefix = styled(Text.BodyBase)`
  position: absolute;
  top: 40px;
  left: 12px;
`;
const RightIcon = styled(Icon.MaterialIcons)`
  position: absolute;
  top: 40px;
  right: 12px;
  opacity: ${props => props.disabled ? 0.4 : 1};
`;
const LeftIcon = styled(Icon.MaterialIcons)`
  position: absolute;
  top: 40px;
  left: 12px;
  opacity: ${props => props.disabled ? 0.4 : 1};
`;
export default function TextField(props) {
  const ref = useRef();
  const focused = useFocus(ref);
  const prefix = props.prefix !== '' && (focused || props.value !== '');
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text.BodyBase, {
    ref: ref,
    color: props.disabled ? Colors.gray200 : props.error ? Colors.error400 : focused ? Colors.advanceBlue400 : Colors.gray300
  }, props.label), prefix && /*#__PURE__*/React.createElement(Prefix, {
    color: Colors.gray600
  }, props.prefix), props.righticon !== '' && /*#__PURE__*/React.createElement(RightIcon, {
    color: Colors.gray400,
    name: props.righticon,
    size: 24,
    disabled: props.disabled,
    onPress: props.righticonPress
  }), props.lefticon !== '' && /*#__PURE__*/React.createElement(LeftIcon, {
    color: Colors.gray400,
    name: props.lefticon,
    size: 24,
    disabled: props.disabled,
    onPress: props.lefticonPress
  }), /*#__PURE__*/React.createElement(StyledTextInput, {
    prefix: prefix,
    value: props.value,
    onChangeText: props.onChangeText,
    placeholder: props.placeholder,
    multiline: props.multiline,
    disabled: props.disabled,
    error: props.error,
    secureTextEntry: props.secureTextEntry,
    lefticon: props.lefticon,
    righticon: props.righticon,
    onBlur: props.onBlur,
    ref: ref
  }), !!props.helper && /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: props.disabled ? Colors.gray100 : props.error ? Colors.error400 : Colors.gray400
  }, props.helper));
}
TextField.defaultProps = {
  value: '',
  label: '',
  placeholder: '',
  multiline: false,
  disabled: false,
  error: false,
  lefticon: '',
  righticon: '',
  helper: '',
  onChangeText: () => null,
  onBlur: () => null,
  prefix: '',
  secureTextEntry: false,
  righticonPress: () => null,
  lefticonPress: () => null
};
TextField.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  multiline: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  lefticon: PropTypes.string,
  righticon: PropTypes.string,
  helper: PropTypes.string,
  onChangeText: PropTypes.func,
  onBlur: PropTypes.func,
  prefix: PropTypes.string,
  secureTextEntry: PropTypes.bool,
  righticonPress: PropTypes.func,
  lefticonPress: PropTypes.func
};
//# sourceMappingURL=text-field.js.map